import { getIncomeTaxAtomClient } from "api/services/automation/config";
import { createContext, useContext } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { ResType } from "types";
import Loader from "components/Loader";

export const ClientIncomeTaxContext = createContext<any>(null);
function ClientIncomeTaxProvider({ children }) {
  const { incometaxid } = useParams();
  const { data, isLoading }: ResType = useQuery(["get-incometax-client", incometaxid], getIncomeTaxAtomClient, {
    enabled: !!incometaxid
  })

  if (isLoading) return <Loader minHeight="60vh" />;

  return (
    <ClientIncomeTaxContext.Provider value={{ data: data?.data }}>
      {children}
    </ClientIncomeTaxContext.Provider>
  )
}

export const useClientIncomeTax = () => useContext(ClientIncomeTaxContext)
export default ClientIncomeTaxProvider